import { useState } from "react";
import { HandCoins } from "lucide-react";
import { AdminTitle } from "@/admin/AdminLayout";
import { FilterBar, DecisionButtons } from "@/admin/Decision";
import { StatusBadge } from "@/components/Brand";
import { useApi } from "@/lib/api";
import { rp, fmtDate } from "@/lib/format";

export default function AdminLoans() {
  const { data, reload } = useApi("/admin/loans");
  const [filter, setFilter] = useState("pending");
  const list = (data || []).filter((l) => filter === "all" || l.status === filter);
  return (
    <div>
      <AdminTitle icon={HandCoins} title="Pinjaman" sub="Tinjau dan setujui pengajuan pinjaman anggota" />
      <FilterBar value={filter} onChange={setFilter} />
      <div className="space-y-3" data-testid="admin-loans-list">
        {list.length === 0 && <p className="text-sm text-slate-500" data-testid="admin-loans-empty">Tidak ada data.</p>}
        {list.map((l) => (
          <div key={l.loan_id} className="bg-white rounded-2xl border border-slate-200 p-4 flex flex-col lg:flex-row lg:items-center gap-3 justify-between">
            <div>
              <div className="flex items-center gap-2"><b>{l.member_name}</b><span className="text-xs text-slate-500">{l.member_no}</span><StatusBadge status={l.status} /></div>
              <div className="text-sm mt-1"><b>{rp(l.amount)}</b> • {l.tenor_months} bln • {l.rate}%/bln • angsuran {rp(l.monthly_installment)}</div>
              <div className="text-xs text-slate-500">Tujuan: {l.purpose} • Diajukan {fmtDate(l.created_at)}</div>
              {l.status === "aktif" && <div className="text-xs text-slate-700 mt-1">Terbayar {rp(l.paid_amount)} dari {rp(l.total_payable)} • Sisa {rp(l.remaining)}</div>}
            </div>
            {l.status === "pending" && <DecisionButtons url={`/admin/loans/${l.loan_id}/decision`} id={l.loan_id} onDone={reload} />}
          </div>
        ))}
      </div>
    </div>
  );
}
